import { getEntities } from 'entman';

import schemas from 'schemas';


export function getSalesOrders(state) {
  return getEntities(state, schemas.SalesOrder);
}
